angular.module('backstage.controllers.widgets', []);

require('./TargetsExceptionsFloatingRuleEditorCtrl');
require('./TargetsExceptionsTagListCtrl');
require('./TaskExecutionProgressModalCtrl');
